module.exports = __webpack_public_path__ + "img/busT0.e15111fb.png";